<template>
  <!-- Footer -->
  <footer id="page-footer">
    <slot>
      <section class="footer-wrapper web-centered text-left">
        <section class="row-first">
          <section class="footer-buttons-wrapper">
            <button
              v-for="(button, i) in buttonContent"
              :key="i"
              class="text-white-main"
              variant="no_background"
              @click="moveTo(button.to)"
            >
              {{ $t(button.title) }}
            </button>
          </section>

          <!-- <SetLanguage save white></SetLanguage> -->
        </section>

        <!-- <div class="info">
          <span>
            <span>법인명 (상호) : 오픈메타 주식회사</span>
            <span class="pipe">|</span>
            <span>사업자등록번호 : 893-81-01040</span>
          </span>
          <span>통신판매업 : 제 2019-서울서초-2565호</span>
          <span>
            <span>주소 : 서울특별시 서초구 강남대로 373, 15층 (서초구, 홍우빌딩)</span>
            <span class="pipe">|</span>
            <span>대표이사 : 박희종</span>
          </span>
          <span>
            <span>대표번호 : 1533-1640</span> <span class="pipe">|</span>
            <span>고객문의 : support@openmeta.kr</span>
          </span>
        </div> -->

        <section class="comp-name">
          <a id="chainlink" href="https://chain.link/badge" target="_blank">
            <img src="https://chain.link/badge-randomness-white" alt="randomness secured with chainlink" />
          </a>

          <article id="xsolla-description">
            <img class="xsolla" :src="`${$s3}/img/common/xsolla.webp?${$ver}`" />
            Xsolla is an authorized global distributor of Open Meta City
          </article>
          <article>Copyright ⓒ Open Meta Inc. All rights reserved</article>
        </section>
      </section>
    </slot>
  </footer>
  <!-- END Footer -->
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'BaseFooter',
  props: {
    classes: String,
  },
  computed: {
    ...mapState(['lang']),
    buttonContent() {
      const valLang = this.lang === 'ko' ? '' : 'en-';
      return this.lang === 'ko'
        ? [
            {
              title: 'etc.footer.intro',
              to: 'http://company.openmeta.city',
            },
            {
              title: 'etc.footer.terms',
              to: `https://sites.google.com/primeblock.co/${valLang}openmetacitytermsofuse`,
            },
            {
              title: 'etc.footer.policy',
              to: `https://sites.google.com/primeblock.co/${valLang}openmetacityprivacypolicy`,
            },
            {
              title: 'etc.footer.faq',
              to: 'https://sour-change-1b9.notion.site/FAQ-538b26d889504d1ca61bcc64f7ab7fe3',
            },
            {
              title: 'etc.footer.qna',
              to: this.$inquiry(this.lang),
            },
          ]
        : [
            {
              title: 'etc.footer.terms',
              to: `https://sites.google.com/primeblock.co/${valLang}openmetacitytermsofuse`,
            },
            {
              title: 'etc.footer.policy',
              to: `https://sites.google.com/primeblock.co/${valLang}openmetacityprivacypolicy`,
            },
            {
              title: 'etc.footer.faq',
              to: 'https://sour-change-1b9.notion.site/Open-Meta-City-FAQ-0f8b366999c24ecfb9a602b746104b00',
            },
            {
              title: 'etc.footer.qna',
              to: this.$inquiry(this.lang),
            },
          ];
    },
  },
  methods: {
    moveTo(link) {
      window.open(link);
    },
  },
  watch: {},
};
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';

#page-footer {
  background: #000000;

  .footer-wrapper {
    padding: 24px 0 50px 0;
    color: #ffffff;

    @include tablet {
      padding: 0 14px;
      padding-top: 16px;
      font-size: 0.7rem;
    }
    .row-first {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #ffffff;

      @include mobile {
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-start;
      }

      .footer-buttons-wrapper {
        width: 100%;
        display: flex;
        gap: 0 clamp(10px, 1vw, 20px);
        transition: $transition;

        @include mobile {
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
        }

        @include tablet {
          .text-white-main {
            padding: 10px 5px;
          }
        }

        button {
          overflow: hidden;
          font-weight: 500;
          font-size: 16px;

          @include tablet {
            font-size: 16px;
          }

          &:hover {
            font-weight: 600;
          }
        }
      }
    }

    .info {
      padding-top: 40px;
      word-break: keep-all;
      display: grid;
      gap: 8px;

      @include tablet {
        padding-top: 12px;
        padding-left: 5px;
        gap: 0px;

        span {
          display: block;
        }

        .pipe {
          display: none;
        }
      }
    }

    .comp-name {
      padding-top: 40px;
      font-weight: 400;
      font-size: 12px;
      word-break: keep-all;
      color: white;
      line-height: 1.5;

      img.xsolla {
        margin-right: 2px;
        height: 1rem;
      }

      @include tablet {
        font-size: 10px;
        padding-bottom: 40px;

        span {
          display: block;
        }

        .pipe {
          display: none;
        }
      }

      #xsolla-description {
        margin-top: 10px;
      }

      a#chainlink {
        margin-right: auto;

        img {
          width: auto;
          height: 50px;

          @include mobile {
            height: 40px;
          }
        }
      }
    }
  }

  select {
    color: white;
    font-size: 14px;

    option {
      color: #333333;
    }
  }
}
</style>
